import repository from '@/repositories/Repository'

const resource = '/companies'

export default {
  get() {
    return repository.bizoo.get(resource).then(r => r.data)
  },
}
